export function middleEllipsis(text, startCharacterCount = 5, endCharacterCount = 4){
    return `${text.slice(0, startCharacterCount)}......${text.slice(-endCharacterCount)}`;
}
